<template>
  <v-row v-if="mostrar">
    <v-col
      v-for="vista in vistas"
      :key="vista.id"
      class="d-flex child-flex"
      cols="4"
    >
      <v-img :src="vista.url" class="grey lighten-2" max-height="150px" contain>
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "MiniGalleryConexion",
  props: {
    mostrar: {
      type: Boolean,
      default: false,
    },
    vistas: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
